import ApiHelper from '../../helpers/apiHelper';
import VoiceIQApiAxiosInstance from '../instances/VoiceIQAPI';
import { store } from '../../app/store';

const getCallHistory = (requestBody: any, tenantCode: string, AccessToken: string) => {
  const config = {
    baseURL: store.getState().auth?.authUser?.RPAPIGW_URL,
    headers: ApiHelper.createHeader(AccessToken, tenantCode),
    url: `/api/v1/activities/search`,
    method: 'post',
    data: requestBody,
  };

  return VoiceIQApiAxiosInstance.request(config);
};

const ScheduledCallsService = { getCallHistory };

export default ScheduledCallsService;